import axios from 'axios';
import { DEFAULT_API_URL, DEFAULT_LOCAL_PATH } from './constents';

const instance = axios.create({
  baseURL: DEFAULT_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const cancelMap = new Map();

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    document.querySelector('.loader-body').classList.remove('hidden');

    // Create a unique key for each request
    const requestKey = `${config.method}:${config.url}`;

    // Cancel the previous request if it's still pending
    if (cancelMap.has(requestKey)) {
      cancelMap.get(requestKey).cancel('Canceled due to a new request.');
    }

    // Create a new cancel token
    const source = axios.CancelToken.source();
    config.cancelToken = source.token;

    // Save the cancel token in the map
    cancelMap.set(requestKey, source);

    return config;
  },
  function (error) {
    // Do something with request error
    document.querySelector('.loader-body').classList.add('hidden');
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    document.querySelector('.loader-body').classList.add('hidden');

    // Remove the cancel token from the map after the request is completed
    const requestKey = `${response.config.method}:${response.config.url}`;
    cancelMap.delete(requestKey);

    return response;
  },
  function (error) {
    if (axios.isCancel(error)) {
      // Do not throw error if the request was canceled
      //console.log('Request canceled', error.message);
      //document.querySelector('.loader-body').classList.add('hidden');
      return new Promise(() => {}); // return a pending promise to avoid error
    }

    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = `${DEFAULT_LOCAL_PATH}`;
    }

    // Do something with response error
    document.querySelector('.loader-body').classList.add('hidden');

    // Remove the cancel token from the map in case of error
    if (error.config) {
      const requestKey = `${error.config.method}:${error.config.url}`;
      cancelMap.delete(requestKey);
    }

    return Promise.reject(error);
  }
);

export default instance;
